import React from 'react';
import { AppRegistry } from 'react-native';
// import {Provider} from 'react-redux';
// import { store, persistor } from './redux/store';
// import {PersistGate} from 'redux-persist/lib/integration/react';
// import { LoaderHOC,NetworkDetector } from './components/hoc';
import { SnackbarWrapper } from './components/molecules/snackbar-wrapper';
import { SnackbarProvider } from 'notistack';
import { connect } from 'react-redux';

import RootRouter from './routers';
import { updateInternetStatus } from './redux/actions/LoginActions';

class App extends React.Component {
  state = {
    openSnackBar: false,
    snackbarData: {
      variant: '',
      message: '',
    },
  };

  componentDidMount() {
    if (window.navigator.onLine === false) {
      this.setState({
        openSnackBar: true,
        snackbarData: {
          variant: 'error',
          message: 'Please connect to internet.',
        },
      });
      this.props.updateInternetStatus(false);
    } else {
      this.props.updateInternetStatus(true);
    }
  }

  render() {
    const {
      openSnackBar,
      snackbarData: { variant, message },
    } = this.state;
    return (
      <SnackbarProvider maxSnack={3}>
        {/* <PersistGate persistor={persistor}>
        <Provider store={store}> */}
        <SnackbarWrapper
          visible={openSnackBar}
          onClose={() => this.setState({ openSnackBar: false })}
          variant={variant}
          message={message}
        />
        <RootRouter/>
        {/* </Provider>
      </PersistGate> */}
      </SnackbarProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateInternetStatus: (status) => dispatch(updateInternetStatus(status)),
  };
};

AppRegistry.registerComponent('App', () => App);

export default connect(mapStateToProps, mapDispatchToProps)(App);
// export default App;
